<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="390"
    >
      <v-card>
        
        <v-app-bar :color="dcolor">
          <v-toolbar-title> {{header}}</v-toolbar-title>
        </v-app-bar>

        <v-card-title class="text-h5">
        </v-card-title>

        <v-card-text>{{message}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="dcolor"
            
            @click="resetDialog"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>


export default {
  name: '',
  props: ['header', 'message', 'dcolor', 'showDialog'],
  data: ()=> ({
    dialog: true
  }),
  created () {
    
  },
  methods: {
    resetDialog() {
      this.$store.dispatch('setDialogState', false)
      this.dialog = false
    }
  }

}

</script>